import * as React from 'react'
require('../base.module.scss')
import { Spinner } from '../Spinner/Spinner'
import { Button } from '../Button/Button'
import { debounce } from '../../utils/utils'
import * as st from './InfiniteScroll.module.scss'
import * as cn from 'classnames'

const defaultTriggerPoint = 50
const defaultDebounce = 100

export interface InfiniteScrollProps {
  trigger: () => Promise<any>,
  disabled?: boolean,
  triggerPoint?: number,
  seeMoreLabel?: string,
  seeMoreHref?: string,
  debounceTime?: number
}

interface InfiniteScrollState {
  isLoadingMore: boolean,
  windowMeasurement: number
}

export class InfiniteScroll extends React.Component<InfiniteScrollProps, InfiniteScrollState> {
  element?: HTMLElement | null
  isCancelled: boolean
  static defaultProps = {
    triggerPoint: defaultTriggerPoint as number,
    debounceTime: defaultDebounce as number,
    disabled: false as boolean
  }

  constructor(props: InfiniteScrollProps) {
    super(props)

    this.isCancelled = false;
    this.state = {
      isLoadingMore: false,
      windowMeasurement: 0
    }
  }

  scrollEvent = debounce(() => {
    this.checkPositionOnPage()
  }, this.props.debounceTime)

  resizeEvent = debounce(() => {
    this.setWindowMeasurement()
    this.checkPositionOnPage()
  }, this.props.debounceTime)

  componentDidMount() {
    // Stop auto-scrolling from back button
    if (!('scrollRestoration' in history)) {
      window.scrollTo(0, 0)
    } else {
      history.scrollRestoration = 'manual'
    }
    this.setWindowMeasurement()
    this.checkPositionOnPage()
    window.addEventListener('scroll', this.scrollEvent)
    window.addEventListener('resize', this.resizeEvent)
  }

  componentWillUnmount() {
    this.isCancelled = true;
    window.removeEventListener('scroll', this.scrollEvent)
    window.removeEventListener('resize', this.resizeEvent)
  }

  checkPositionOnPage() {
    if (this.shouldLoadMore()) {
      this.triggerCb()
    }
  }

  setWindowMeasurement() {
    !this.isCancelled && this.setState(() => ({
      windowMeasurement: window.innerHeight
    }))
  }

  shouldLoadMore() {
    if (this.props.disabled || !this.element || this.state.isLoadingMore) {
      return false
    }

    const elementPosition = this.element.getBoundingClientRect().top
    const hasScrolledToEnd = elementPosition - this.state.windowMeasurement < this.props.triggerPoint!
    return (!this.state.isLoadingMore && hasScrolledToEnd)
  }

  triggerCb() {

    !this.isCancelled && this.setState({
      isLoadingMore: true
    })

    return this.props.trigger().then(() => {
      !this.isCancelled && this.setState({ isLoadingMore: false })
    })
  }

  render() {
    return (
      <div>
        <noscript>
          {
            this.props.seeMoreHref &&
            <Button href={this.props.seeMoreHref} className={cn(st.seeMore, 'u-pagination')}>
              {this.props.seeMoreLabel}
            </Button>
          }
        </noscript>
        <div ref={(e) => this.element = e}>
          {
            (!this.props.disabled && this.state.isLoadingMore) && <Spinner />
          }
        </div>
      </div>
    )
  }
}
